// extracted by mini-css-extract-plugin
export var numpadContainer = "_my-1";
export var phoneButton = "_my-0";